"use client"

import type { ReactNode } from "react"

interface SubjectProgressProps {
  icon: ReactNode
  subject: string
  percentage: number
  color: string
}

export function SubjectProgress({ icon, subject, percentage, color }: SubjectProgressProps) {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
      <div className="flex items-center gap-3 w-full sm:w-40 flex-shrink-0">
        <div className="p-2 bg-slate-100 rounded-md flex items-center justify-center">{icon}</div>
        <span className="font-semibold text-slate-900">{subject}</span>
      </div>
      <div className="w-full bg-slate-200 rounded-full h-6 overflow-hidden">
        <div
          className={`${color} h-6 rounded-full flex items-center justify-end pr-2 transition-all duration-500`}
          style={{ width: `${percentage}%` }}
        >
          <span className="text-sm font-bold text-white">{percentage}%</span>
        </div>
      </div>
    </div>
  )
}
